import { useNavigate } from "react-router-dom";

export const useSectionNav = () => {
  const navigate = useNavigate();
  return (path) => navigate(path);
};
